import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, ref, onUnmounted, onMounted } from 'vue'

  import CoursePanelLoader from '@/components/loaders/CoursePanelLoader.vue'
  import CourseDetailsActionLoader from '@/components/loaders/CourseDetailsActionLoader.vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import CourseTypeToggle from '@/components/course/course-panel-contents/CourseTypeToggle.vue'
  import CourseProgress from '@/components/course/course-panel-contents/CourseProgress.vue'
  import CourseDetailsAction from '@/components/course/course-panel-contents/CourseDetailsAction.vue'
  import ExamDetails from '@/components/course/course-panel-contents/ExamDetails.vue'
  import WebinarDetails from '@/components/course/course-panel-contents/WebinarDetails.vue'
  import CourseExpiredBanner from '@/components/course/course-panel-contents/CourseExpiredBanner.vue'
  import BuyCourseDetails from '@/components/course/course-panel-contents/BuyCourseDetails.vue'
  import ExamAction from '@/components/course/course-panel-contents/ExamAction.vue'

  import { useRouter } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useI18n from '@/composables/useI18n'

  import { CourseModule } from '@/store/modules/course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoursePanel',
  setup(__props) {

  const router = useRouter()
  const {
    course,
    nextModuleToStart,
    isTrialExpired,
    navigateToModule,
    navigateToCourseContent,
    showStartCourseForFreeModal,
  } = useCourse()
  const { cardEmptyImage } = useIcons()
  const { hasValidUser, is34ACompany } = useCommonMixin()
  const { translateString } = useI18n()

  const courseBundle = computed(() => CourseModule.courseBundle)

  const activeCourseType = computed(() => course.value?.courseType || 'written')

  const isCourseContentLoading = ref(false)

  let loadingTimeout: number | null = null

  const loadingContent = computed(() => {
    if (is34ACompany.value) {
      return !course.value?.id
    }
    return !courseBundle.value
  })

  const fetchingCourseModules = computed(() => {
    if (!course.value?.id) return false
    return CourseModule.coursesModuleMap[course.value?.id] === undefined
  })

  const nextLesson = computed(() => {
    if (!nextModuleToStart.value) return null

    return nextModuleToStart.value.lessons.find((lesson) => !lesson.completed) || nextModuleToStart.value.lessons[0]
  })

  const nextActionDisabled = computed(() => {
    if (!hasValidUser.value) return false
    return isTrialExpired.value(course.value) && !course.value?.purchased
  })

  const handleCourseTypeToggle = (type: 'written' | 'oral') => {
    if (courseBundle.value) {
      const selectedCourse = courseBundle.value.courses.find((c) => c.courseType === type)

      if (selectedCourse) {
        CourseModule.setCourse(selectedCourse)
      }
    }
  }

  const handleNextActionClick = () => {
    if (!hasValidUser.value) {
      router.push('/login')
      return
    }

    if (course.value?.purchased || course.value?.expired) {
      navigateToCourseContent(nextModuleToStart.value, nextLesson.value, course.value!.id, false)
    } else if (course.value?.trial) {
      navigateToModule(course.value!.id, nextModuleToStart.value, nextLesson.value)
    } else {
      showStartCourseForFreeModal()
    }
  }

  const handleExamActionClick = async () => {
    if (!hasValidUser.value) {
      router.push('/login')
      return
    }

    if (!course.value?.trial) {
      showStartCourseForFreeModal({
        routeToExam: true,
      })
    } else {
      router.push(`/courses/${course.value?.id}/exam/${course.value?.exam?.id}/start`)
    }
  }

  const fetchCourseModules = (courseId: string) => {
    const courseModules = CourseModule.coursesModuleMap[courseId]

    if (courseModules === undefined) {
      CourseModule.getCourseModules(courseId)
    }
  }

  watch(course, (value) => {
    if (value?.id) {
      fetchCourseModules(value.id)

      isCourseContentLoading.value = true
      if (loadingTimeout) {
        clearTimeout(loadingTimeout)
      }

      loadingTimeout = window.setTimeout(() => {
        isCourseContentLoading.value = false
      }, 250)
    }
  })

  onMounted(() => {
    if (course.value?.id) {
      fetchCourseModules(course.value.id)
    }
  })

  onUnmounted(() => {
    if (loadingTimeout) {
      clearTimeout(loadingTimeout)
    }
  })

return { __sfc: true,router, course, nextModuleToStart, isTrialExpired, navigateToModule, navigateToCourseContent, showStartCourseForFreeModal, cardEmptyImage, hasValidUser, is34ACompany, translateString, courseBundle, activeCourseType, isCourseContentLoading, loadingTimeout, loadingContent, fetchingCourseModules, nextLesson, nextActionDisabled, handleCourseTypeToggle, handleNextActionClick, handleExamActionClick, fetchCourseModules, computed, watch, ref, onUnmounted, onMounted, CoursePanelLoader, CourseDetailsActionLoader, PlaceholderShimmer, CourseTypeToggle, CourseProgress, CourseDetailsAction, ExamDetails, WebinarDetails, CourseExpiredBanner, BuyCourseDetails, ExamAction, useRouter, useCourse, useIcons, useCommonMixin, useI18n, CourseModule }
}

})